import { signOut } from 'firebase/auth';
import { auth } from '../firebase/client';

export type MembershipBlockMode = 'owner' | 'member';

export function MembershipBlockedScreen({
  mode,
  ownerContactLine,
}: {
  mode: MembershipBlockMode;
  ownerContactLine?: string | null;
}) {
  const isOwner = mode === 'owner';

  return (
    <div className="membership-block-screen">
      <div className="membership-block-card">
        <div className="membership-block-icon" aria-hidden>
          {isOwner ? '⏱' : '⏸'}
        </div>
        <h1 className="membership-block-title">
          {isOwner ? 'Upgrade your plan to continue' : 'Your account is on hold'}
        </h1>
        <p className="membership-block-body">
          {isOwner
            ? 'Your Premium subscription has expired. Renew from the Phirti mobile app to restore access to your Company Workspace.'
            : 'Contact the owner to renew the subscription and restore access.'}
        </p>
        {!isOwner && ownerContactLine ? (
          <p className="membership-block-contact">{ownerContactLine}</p>
        ) : null}
        {isOwner ? (
          <p className="membership-block-hint">
            Open Phirti on your phone, sign in with the same number, and choose Monthly or Yearly to renew.
          </p>
        ) : null}
        <button
          type="button"
          className="ph-btn ph-btn--outline membership-block-signout"
          onClick={() => void signOut(auth())}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
